module.exports = __webpack_public_path__ + "img/icon-community-mew.fe05f5ad.svg";